var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row flex-items-xs-middle"},[_c('div',{staticClass:"state-circle mr-1",class:_vm.stateClassName}),_c('b-button',{staticClass:"text-capitalize",attrs:{"variant":"modal"},on:{"click":_vm.show}},[_vm._v(" Show ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }